import classNames from 'classnames';
import React from 'react';



type Props = {
	/** List of plan benefits */
	benefits: React.ReactNode,
	/** Apply enterprise highlight */
	isEnterprise?: boolean,
	/** Possible to indent this element by left gap from others */
	isIndented?: boolean,
};



const PlansComparisonTableColumn: React.FC<Props> = (props) => {
	const {
		benefits,
		isEnterprise,
		isIndented,
	} = props;

	const componentClasses = classNames({
		'plans-comparison-table-column': true,
		'plans-comparison-table-column--is-enterprise': isEnterprise,
		'plans-comparison-table-column--is-indented': isIndented,
		'dark-bg-context': isEnterprise,
	});

	return (
		<div className={componentClasses}>
			<div className="plans-comparison-table-column__benefits">
				{benefits}
			</div>
		</div>
	);
};



export default PlansComparisonTableColumn;
